import { Routes, Route, Navigate } from 'react-router-dom'
import Layout from './components/Layout'
import PrivateRoute from './components/PrivateRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import ArticleList from './pages/ArticleList'
import ArticleDetail from './pages/ArticleDetail'
import UserAnalysis from './pages/UserAnalysis'
import Comments from './pages/Comments'
import Reports from './pages/Reports'
import Settings from './pages/Settings'
import MessageAnalysis from './pages/MessageAnalysis'
import CrawlLogs from './pages/CrawlLogs'
import WechatApi from './pages/WechatApi'
import AllWechatApis from './pages/AllWechatApis'
import WechatConfigPage from './pages/WechatConfigPage'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/articles" element={<ArticleList />} />
        <Route path="/articles/:id" element={<ArticleDetail />} />
        <Route path="/users" element={<UserAnalysis />} />
        <Route path="/messages" element={<MessageAnalysis />} />
        <Route path="/comments" element={<Comments />} />
        <Route path="/reports" element={<Reports />} />
        <Route path="/crawl-logs" element={<CrawlLogs />} />
        <Route path="/wechat-api" element={<WechatApi />} />
        <Route path="/all-wechat-apis" element={<AllWechatApis />} />
        <Route path="/wechat-config" element={<WechatConfigPage />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
